<template>
    <div id="container" :class="{'loaded':mounted}">
        <div id="side" @navigated="closeNavigation">
            <h-navigation @navigated="closeNavigation" />
        </div>
        <div id="main">
            <button id="menubtn" type="button" class="btn btn-default d-xl-none" aria-label="Left Align" @click="toggleNavigation">
                <svg width="1.5rem" height="1.5rem" viewBox="0 0 16 16" class="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                </svg>
            </button>
            <div class="container-fluid d-block d-lg-none">
                <a id="top"></a>
                <div class="row justify-content-center">
                    <div class="col-8 text-center">
                        <img id="logo" src="../assets/tplogo@1x.png" alt="Logo Theresa und Paul" />
                    </div>
                </div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Slideout from 'slideout'
import Navigation from '@/components/Navigation'

export default {
    name: 'container',
    components: {
        'h-navigation': Navigation
    },
    data() {
        return {
            mounted: false
        }
    },
    mounted() {
        this.$data.mounted = true

        let offset = document.getElementById('side').offsetWidth

        let slide = this.slideout = new Slideout({
            menu: document.getElementById('side'),
            panel: document.getElementById('main'),
            padding: offset,
            tolerance: 70
        })

        this.$router.afterEach(() => slide.close())
    },
    methods: {
        toggleNavigation() {
            this.slideout.toggle()
        },
        closeNavigation() {
            this.slideout.close()
        }
    }
}
</script>

<style lang="scss">
@import '~bootstrap';

@keyframes fadeIn {
    40% {
        opacity: 0;
        transform: scale(1.5);
    }

    60% {
        opacity: 0;
        transform: scale(1.2);
    }
   
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

#logo {
    margin-top: 1rem;
    max-width: 80%;
    max-height: 15rem;
}

#menubtn {
    position: fixed;
    top: 0.3rem;
    left: 0.3rem;
    z-index: 10;
}

@include media-breakpoint-down(md) {
    #main {
        overflow-x: hidden;
        box-shadow:  0px 0px 12px 0px rgba(0,0,0,0.75);
        z-index: 2;
        position: relative;
        min-height: 100vh;
    }

    #side {
        z-index: 1;
        height: 100vh;
        position: fixed;
        top: 0;
        bottom: 0;
        width: 14rem;
        //background: linear-gradient(to top, rgb(22, 35, 51), rgb(15, 22, 36));
        background: linear-gradient(120deg, rgb(255, 255, 255) 0%, #d4dfe4 100%);
    }

    .slideout-menu {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 0;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        display: none;
    }

    .slideout-panel {
        position: relative;
        z-index: 1;
        will-change: transform;
        background: linear-gradient(120deg, #fdfbfb 0%, #d4dfe4 100%);
    }

    .slideout-open,
    .slideout-open body,
    .slideout-open .slideout-panel {
        overflow-x: hidden;
    }

    .slideout-open .slideout-menu {
        display: block;
    }
}

@include media-breakpoint-only(lg) {

    #container {
        overflow: hidden;
    }

    #main {
        overflow: hidden;
        z-index: 2;
        position: relative;
        height: 100vh;
        margin-left: 0 !important;
    }

    #side {
        z-index: 1;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        width: 14rem;
        background: linear-gradient(to top, rgb(22, 35, 51), rgb(15, 22, 36));
    }

    .slideout-menu {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 0;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        display: none;
    }

    .slideout-panel {
        position: relative;
        z-index: 1;
        will-change: transform;
        background: linear-gradient(120deg, #fdfbfb 0%, #d4dfe4 100%);
    }

    .slideout-open,
    .slideout-open body,
    .slideout-open .slideout-panel {
        overflow-x: hidden;
    }

    .slideout-open .slideout-menu {
        display: block;
    }
}

@include media-breakpoint-up(lg) {
    #container {
        box-shadow:         0px 0px 5px 3px rgba(30, 30, 30, 0.75);

        margin: 2rem;
        height: auto;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;

        opacity: 0;
        transform: scale(1.5);

        background-image: linear-gradient(120deg, #fdfbfb 0%, #d4dfe4 100%);

        &.loaded {
            animation: fadeIn 0.8s ease-in 0.4s forwards;
        }

        #side {
            background: #141E30;
            background: linear-gradient(to top, rgb(22, 35, 51), rgb(15, 22, 36));

            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 14rem;
        }

        #main {
            overflow-x: hidden;
            overflow-y: auto;

            height: 100%;

            margin-left: 14rem;
            padding: 1rem;
        }

        #main > div {
            height: 100%;
        }
    }    
}
</style>
